<template>
  <div
    class="layer-f"
    @mouseenter="toolActivate = true"
    @mouseleave="toolActivate = false"
  >
    <!-- <el-tooltip content="Bottom center" placement="bottom" effect="light"> -->
    <transition name="el-fade-in-linear">
      <div class="layer-pop" v-show="toolActivate">
        <div
          :class="['layer-pop-icon', item.isCheck ? 'active-i' : '']"
          v-for="(item, index) in tools"
          :key="index"
          @click="control(item, index)"
        >
          <i :class="['iconfont', item.icon]"></i>
          <div>{{ item.name }}</div>
        </div>
      </div>
    </transition>
    <div class="layer-box">
      <div class="layer-box-i">
        <img
          v-show="!toolActivate"
          class="imgStyle"
          src="../../assets/images/gj.png"
          alt=""
        />
        <img
          v-show="toolActivate"
          class="imgStyle"
          src="../../assets/images/gj-activate.png"
          alt=""
        />
        <!-- <i class="iconfont icon-gongju2"></i> -->
      </div>
      <div class="layer-box-t">
        <span style="display: block; color: rgb(192, 196, 204)">工具</span>
      </div>
      <div class="layer-box-t">
        <i class="iconfont icon-xiala" style="color: rgb(192, 196, 204)"></i>
      </div>
    </div>

    <!-- </el-tooltip> -->
    <!-- <transition name="el-zoom-in-top">
      <div class="layer-pop" v-show="show">
        <div class="layer-pop-icon" @click="mark">
          <i class="iconfont icon-biaozhu"></i>
          <div>标记</div>
        </div>
        <div class="layer-pop-icon" @click="measure('Polygon')">
          <i class="iconfont icon-xuanmianmianji"></i>
          <div>测面</div>
        </div>
        <div class="layer-pop-icon" @click="measure('LineString')">
          <i class="iconfont icon-juli"></i>
          <div>测距</div>
        </div>
        <div class="layer-pop-icon" @click="clear">
          <i class="iconfont icon-qingchu2"></i>
          <div>清除</div>
        </div>
      </div>
    </transition> -->
  </div>
</template>
<script>
export default {
  name: "layer",
  props: {
    mapView: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      toolActivate: false,
      show: false,
      layerIndex: null,
      tools: [
        {
          name: "标记",
          icon: "icon-biaozhu",
          eventName: "mark",
          isCheck: false,
        },
        {
          name: "测面",
          icon: "icon-xuanmianmianji",
          eventName: "measure",
          args: "Polygon",
          isCheck: false,
        },
        {
          name: "测距",
          icon: "icon-juli",
          eventName: "measure",
          args: "LineString",
          isCheck: false,
        },
        {
          name: "清除",
          icon: "icon-qingchu2",
          eventName: "clear",
          isCheck: false,
        },
      ],
      data: [],
      markFontColor: {
        type: String,
        default: "#000",
      },
    };
  },
  mounted() {
    // this.data = layerData;
  },
  methods: {
    control(item, index) {
      this.tools.forEach((i, j) => {
        if (j == index) {
          i.isCheck = !i.isCheck;
        } else {
          i.isCheck = false;
        }
        if (j == 0 && i.isCheck == false) {
          //移除事件
          this.mapView.removeSingleClickListener();
        }
        if ((j == 1 || j == 2) && i.isCheck == false) {
          //停止绘画
          this.mapView.stopDraw();
        }
      });
      if (this.tools[index].isCheck) {
        let that = this;
        this.$options.methods[item.eventName](that, item.args ? item.args : "");
      }
      if (item.name == "清除") {
        this.toolActivate = false;
      } else {
        this.toolActivate = true;
      }
    },
    drawGeometry(that, val) {
      that.mapView.drawGeometry(val);
    },
    measure(that, val) {
      that.mapView.removeSingleClickListener();
      that.mapView.measure(val);
    },
    clear(that) {
      that.mapView.clearDraw();
      that.drawCords = [];
    },
    //标注
    mark(that) {
      that.mapView.addSingleClickCallBack((feature, coordinate) => {
        that.mapView.addVectorPoint(
          coordinate,
          "标记点",
          require("../../assets/leadCockpitImage/mark.png"),
          undefined,
          this.markFontColor,
          undefined,
          10,
          [0.8, 28]
        );
      });
    },
    //返回中心
    centerTo(that) {
      that.mapView.flyTo(that.position);
    },
    // 绘制图形后触发
    draw(that, val) {
      that.mapView.drawGeometry(
        "Polygon",
        (coords) => {
          console.log("绘制图形", coords);
          that.drawCords.push(coords);
          that.mapView.stopDraw();
        },
        undefined
      );
      //   console.log("ddd", that.mapView.draw);
      //   that.mapView.drawGeometry(val);
      //   that.mapView.draw(val);
      //   that.draw(val);
    },
    // 导入Shp文件
    importShp(that) {
      //   console.log("导入shp文件", that.$refs.uploadBox);
      //   this.$ref.uploadBox.submit();
    },
  },
};
</script>
<style scoped>
.layer-pop::after {
  position: absolute;
  display: inline-block;
  top: -4px;
  left: calc(50% - 4px);
  width: 0px;
  height: 0px;
  content: "";
  border-style: solid;
  border-width: 4px;
  border-color: #fff #fff transparent transparent;
  transform: rotate(-45deg);
  box-shadow: 2px -2px 2px rgba(0, 0, 0, 0.1);
}
.layer-f {
  position: relative;
}
.layer-box {
  /* width: 80px; */
  height: 30px !important;
  padding: 2px 5px;
  text-align: center;
  color: #837e7e;
  background: #fff;
  display: flex;
  align-items: center;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  cursor: pointer;
}
.layer-box-i > i {
  color: #0657b4;
  font-size: 18px;
}
.layer-box-t {
  font-size: 13px;
  margin-left: 4px;
}

.layer-pop {
  position: absolute;
  top: 45px;
  left: 0px;
  background: #fff;
  color: #837e7e;
  /* border: 1px solid #c9c9c9; */
  /* box-shadow: #d9d8d8 0px 1px 2px 2px; */
  border-radius: 4px;
  /* padding: 10px; */
  font-size: 13px;
  z-index: 1;
  padding: 10px;
  box-shadow: 0px 1px 7px rgba(0, 0, 0, 0.1);
}

.layer-pop-icon {
  padding: 5px;
  display: flex;
  cursor: pointer;
}
.layer-pop-icon > div {
  margin-left: 10px;
  width: 30px;
  text-align: center;
}
/* .layer-pop::before {
  content: "";
  width: 0;
  height: 0;
  border: 8px solid;
  position: absolute;
  top: -16px;
  right: 26px;
  border-color: transparent transparent #fff transparent;
} */

.layer-pop-icon:hover {
  color: #0cd7f5;
}
.active-i {
  color: #2785de;
  font-weight: 600;
}
.imgStyle {
  width: 12px;
}
</style>

